import type { Dispatch, SetStateAction } from 'react'

import { TimeSettingsEnumsTimeTypeEnum } from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateCustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useCreateCustomTimeRangeCategory'

export interface CustomTimeRangeCategoryFormType {
  id?: number
  companyId: number
  name: string
  timeType: TimeSettingsEnumsTimeTypeEnum
  archived: boolean
  default: boolean
  categoryType: string
}

interface Props {
  companyId: number
  setModalOpen: Dispatch<SetStateAction<boolean>>
}

const CreateCustomTimeRangeCategoryForm = ({ companyId, setModalOpen }: Props) => {
  const { create } = useCreateCustomTimeRangeCategory()

  const defaultValues = {
    companyId: companyId,
    name: '',
    timeType: 'regular',
    archived: false,
    default: false,
    categoryType: 'special_hour',
  } as const

  const form = useForm({
    defaultValues: defaultValues,
    onSubmit: async (data, { setErrors }) => {
      const payload = {
        ...data,
      }

      const result = await create(payload)
      const handled = handleResult(result, setErrors)
      if (handled.success) {
        track(trackingEvents.timeTracking.addWorkTimeCategory, {
          company_id: data.companyId,
          category_id: handled.data.customTimeRangeCategory?.id,
          category_name: data.name,
          time_type: data.timeType,
        })
        setModalOpen(false)
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        form.resetForm()
      }

      return handled
    },
  })

  return form
}

export default CreateCustomTimeRangeCategoryForm
